import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import { Box, Typography } from '@mui/material';

import useBranding from '../hooks/useBranding';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const branding = useBranding();

  const logo = (
    <Box sx={{ width: 60, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      {branding.logo ? (
        <Box
          component="img"
          src={branding.logo}
          alt={branding.name || 'logo'}
          sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      ) : (
        <Typography variant="h5" noWrap sx={{ fontWeight: 700, color: sx?.color || 'primary.main' }}>
          {branding.name}
        </Typography>
      )}
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
